<template>
  <v-container>
    <v-row justify="center" class="flex-sm-row-reverse">
      <v-col sm="6" md="4">
        <v-card class="fill-height premium-plan">
          <v-img :src="plan.imagePath" lazy cover></v-img>
          <v-card-text class="text-center">
            <div class="mb-1 text-h4 black--text">
              <span class="mouse-memoirs">{{
                $t("view.V6SlideUpgradeR2.planName")
              }}</span>
            </div>
            <div class="mb-5 text-caption">
              <!-- {{ $t("view.V6SlideUpgradeR2.planValue") }} -->
              {{ $t("view.V6SlideUpgradeR2.mathSkillsValue") }}
            </div>
            <!-- <div class="mb-3" style="font-size: 20px;">{{ $t('view.V6SlideUpgradeR2.planDuration') }}</div> -->
            <div class="mb-5">
              <div
                v-if="appliedCoupon"
                class="red--text"
                :class="{ 'text-decoration-line-through': appliedCoupon }"
              >
                {{ $t("view.V6SlideUpgradeR2.originalPrice") }} RM {{ originalPrice }}
              </div>
              <div v-if="appliedCoupon" class="text-h6 green--text mb-2">
                {{ $t("view.V6SlideUpgradeR2.discount") }} {{ formatDiscount(appliedCoupon) }}
              </div>
              <div class="text-h5 black--text">
                {{
                  appliedCoupon
                    ? formatPrice(finalPrice)
                    : $t("view.V6SlideUpgradeR2.discountedPrice") + " RM " + originalPrice
                }}
              </div>
            </div>
            
            <!--
            <div v-if="api.isError" class="error--text mb-3">
              {{ api.error }}
            </div>

            <div v-if="stripeApi.isError" class="error--text mb-3">
              {{ stripeApi.error }}
            </div>
            <div v-if="isOpenCoupon" class="d-flex align-center justify-center">
              <div>
                <v-form
                  ref="formName"
                  class="flex-grow-1"
                  v-model="valid"
                  lazy-validation
                  @submit.prevent
                >
                  <v-text-field
                    v-model="coupon"
                    :rules="couponRules"
                    :label="$t('view.V6SlideUpgradeR2.couponCode')"
                    required
                    outlined
                    rounded
                    dense
                    :disabled="appliedCoupon !== null"
                  ></v-text-field>
                </v-form>
              </div>
              <v-btn
                v-if="isOpenCoupon && !appliedCoupon"
                color="success"
                large
                text
                class="ml-2 mb-6"
                plain
                :loading="api.isLoading"
                @click="apply()"
              >
                   {{ $t("view.V6SlideUpgradeR2.applyCoupon") }}
              </v-btn>
              <v-btn
                v-if="isOpenCoupon && appliedCoupon"
                color="error"
                large
                text
                class="ml-2 mb-6"
                plain
                @click="removeCoupon()"
              >
                Remove
              </v-btn>
            </div>

            -->

            <div v-if="auth && auth.Session" class="payment-section mb-4">
              <v-divider class="mb-4"></v-divider>
              <div class="text-h6 mb-3">{{ $t("view.V6SlideUpgradeR2.choosePaymentMethod") }}</div>

              <!-- Stripe Payment Button -->
              <!-- <v-btn
                x-large
                block
                color="primary"
                class="mx-auto stripe-button mb-3 animate-glow"
                rounded
                :loading="stripeApi.isLoading"
                @click="clickStripe()"
              >
                <v-icon left>mdi-credit-card</v-icon>
               {{ $t("view.V6SlideUpgradeR2.creditCardButton") }}
              </v-btn> -->

              <v-btn
                x-large
                block
                color="primary"
                class="mx-auto animate-glow"
                rounded
                @click="trackEvent"
              >
                <v-icon left>mdi-account-arrow-up</v-icon>
                {{ $t("view.V6SlideUpgradeR2.bankTransferButton") }}
              </v-btn>

              <stripe-checkout
                ref="checkoutRef"
                mode="subscription"
                :pk="publishableKey"
                :line-items="lineItems"
                :success-url="successURL"
                :cancel-url="cancelURL"
                :session-id="sessionId"
                @loading="(v) => (loading = v)"
                style="display: none"
              />
            </div>
            <div v-else class="payment-section mb-4">
              <v-divider class="mb-4"></v-divider>
              <v-btn
                x-large
                block
                color="primary"
                class="mx-auto mb-3 animate-glow"
                rounded
                @click="goRegister()"
              >
                <v-icon left> mdi-account-plus</v-icon>
                {{ $t("view.PageMainHome.slide_v3_pitch_button") }}
              </v-btn>
              <div>{{ $t("view.V6SlideUpgradeR2.ownAccount") }}</div>
              <v-btn text color="primary" plain class="mb-3" @click="goLogin()"
                >{{ $t("action.login_now") }}</v-btn
              >
            </div>
            <!-- <div class="text-center mt-3">{{ $t('view.V6SlideUpgradeR2.giftMessage') }}</div> -->
          </v-card-text>
        </v-card>
      </v-col>
      <v-col sm="6" md="4">
        <v-card class="fill-height premium-plan">
          <v-card-text class="text-center">
            <div class="text-h6 mb-3">
              {{ $t("view.V6SlideUpgradeR2.header") }}
            </div>
            <!--
            <div class="mb-3">
              <v-btn
                block
                large
                rounded
                outlined
                color="success"
                class="mb-1"
                >{{ $t("view.V6SlideUpgradeR2.readingHabitTitle") }}</v-btn
              >
              <div class="text-caption">
                {{ $t("view.V6SlideUpgradeR2.readingHabitValue") }}
              </div>
              <v-list dense class="text-left">
                <v-list-item
                  v-for="(feature, index) in featureReading"
                  :key="index"
                >
                  <v-list-item-icon>
                    <v-icon color="success">mdi-check-circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      $t(`view.V6SlideUpgradeR2.readingFeature${index + 1}`)
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
            -->
            <div>
              <v-btn
                block
                large
                rounded
                outlined
                color="success"
                class="mb-1"
                >{{ $t("view.V6SlideUpgradeR2.mathSkillsTitle") }}</v-btn
              >
              <div class="text-caption">
                {{ $t("view.V6SlideUpgradeR2.mathSkillsValue") }}
              </div>
              <v-list dense class="text-left">
                <v-list-item
                  v-for="(feature, index) in featureMaths"
                  :key="index"
                >
                  <v-list-item-icon>
                    <v-icon color="success">mdi-check-circle</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>{{
                      $t(`view.V6SlideUpgradeR2.mathFeature${index + 1}`)
                    }}</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/* global fbq */
import ImagePremium from "@/assets/PageMainHomeV6/BannerBrightFuture.png";
import { StripeCheckout } from "@vue-stripe/vue-stripe";
import { mapState } from "vuex";

export default {
  data: () => ({
    plan: {
      imagePath: ImagePremium,
    },
    originalPrice: 540, 
    //BOC:[api]
    api: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    //BOC:[stripe api]
    stripeApi: {
      isLoading: false,
      isError: false,
      error: null,
      url: null,
    },
    //EOC
    featureReading: [1, 2, 3], // Dummy array for looping purposes
    featureMaths: [1, 2], // Dummy array for looping purposes
    isOpenCoupon: true,
    coupon: null,
    couponRules: null,
    valid: false,
    appliedCoupon: null,
    couponSuccess: false,
    isLoading: false,
    publishableKey: process.env.VUE_APP_STRIPE_PUBLISHABLE_KEY,
    loading: false,
    lineItems: [
      {
        price: process.env.VUE_APP_STRIPE_PRICE_ID,
        quantity: 1,
      },
    ],
    successURL: null,
    cancelURL: null,
    sessionId: null,
  }),
  components: {
    StripeCheckout,
  },
  computed: {
    ...mapState({
      auth: (state) => state.auth.data,
      upgrade: (state) => state.upgrade.data,
    }),
    finalPrice() {
      if (!this.appliedCoupon) return this.originalPrice;

      return this.calculateDiscountedPrice(
        this.originalPrice,
        this.appliedCoupon
      );
    },
    upgradeButtonText() {
       if (this.appliedCoupon && this.appliedCoupon.discountType === 'percentage') {
        return `${this.$t("view.V6SlideUpgradeR2.upgradeButtonWithSaving")} ${this.appliedCoupon.discountValue}%`;
      } else if (this.appliedCoupon && this.appliedCoupon.discountType === 'fixed_amount') {
        return `${this.$t("view.V6SlideUpgradeR2.upgradeButtonWithSaving")} RM ${this.appliedCoupon.discountValue}`;
      }
      return this.$t("view.V6SlideUpgradeR2.upgradeButton");
    }
  },
  created() {
    this.couponRules = [
      // (v) => !!v || this.$t("view.V6SlideUpgradeR2.couponCodeRequired"),
    ];
    //BOC:[api]
    this.api.url = `${this.$api.servers.sso}/api/v1/en/account/upgrade/checkCoupon`;
    this.api.callbackReset = () => {
      this.api.isLoading = true;
      this.api.isError = false;
      this.couponSuccess = false;
    };
    this.api.callbackError = (e) => {
      this.api.isLoading = false;
      this.api.isError = true;
      this.api.error = e;
      this.couponSuccess = false;
    };
    this.api.callbackSuccess = (resp) => {
      this.api.isLoading = false;
      this.api.isError = false;
      this.appliedCoupon = resp.CouponCode;
      this.sessionId = resp.sessionId;
      this.couponSuccess = true;
    };
    //EOC

    //BOC:[stripe api]
    this.stripeApi.url = `${this.$api.servers.sso}/api/v1/en/account/upgrade/createSession`;
    this.stripeApi.callbackReset = () => {
      this.stripeApi.isLoading = true;
      this.stripeApi.isError = false;
    };
    this.stripeApi.callbackError = (e) => {
      this.stripeApi.isLoading = false;
      this.stripeApi.isError = true;
      this.stripeApi.error = e;
    };
    this.stripeApi.callbackSuccess = (resp) => {
      this.stripeApi.isLoading = false;
      this.stripeApi.isError = false;
      this.sessionId = resp.sessionId;
      // Redirect to Stripe checkout after session is created
      this.$refs.checkoutRef.redirectToCheckout({ sessionId: this.sessionId });
    };
    //EOC
  },
  beforeDestroy() {
    //
  },
  mounted() {
     let appliedCoupon = this.$_.cloneDeep(this.upgrade.coupon);
      if (appliedCoupon && this.upgrade.isClicked) {
        this.isOpenCoupon = true
        this.appliedCoupon = appliedCoupon.key;
        this.coupon = appliedCoupon.key 
        this.apply()
      }
      this.$store.commit("updateClick", { isClicked: false, coupon: this.appliedCoupon });
    this.successURL = `${
      process.env.VUE_APP_URL
    }/${this.$_getLocale()}/dashboard`;
    this.cancelURL = `${process.env.VUE_APP_URL}/${this.$_getLocale()}/upgrade`;
  },
  methods: {
    goLogin() {
      this.$store.commit("updateClick", {
        isClicked: true,
        coupon: this.appliedCoupon,
      });

      this.$router.push({ name: "PageMainLogin" });
    },
    goRegister() {
      this.$store.commit("updateClick", {
        isClicked: true,
        coupon: this.appliedCoupon,
      });

      this.$router.push({ name: "PageMainRegister" });
    },
    async clickStripe() {
      // Create Stripe session via API
      this.createStripeSession();
    },
    createStripeSession() {
        let self = this;
        setTimeout(function () {
          self.stripeApi.isLoading = true;
          self.stripeApi.params = {
            planPricingKey: process.env.VUE_APP_PLAN_PRICING_KEY,
            couponKey: self.appliedCoupon ? self.coupon : null,
          };
          self.$api.fetch(self.stripeApi);
        });
     
    },
    trackEvent() {
      //BOC: [facebook pixel]
      if (typeof fbq !== "undefined") {
        fbq("track", "Lead");
      }
      //EOC
      this.$store.commit("updateClick", {
        isClicked: true,
        coupon: this.appliedCoupon,
      });
      this.$router.push({ name: "PageAccountUpgradeForm" });
    },
    openCoupon() {
      this.isOpenCoupon = true;
    },
    closeCoupon() {
      this.isOpenCoupon = false;
      this.api.isError = false;
      this.couponSuccess = false;
      this.coupon = null;
      this.appliedCoupon = null;
    },
    removeCoupon() {
      this.appliedCoupon = null;
      this.coupon = null;
      this.couponSuccess = false;
      this.api.isError = false;
    },
    apply() {
      if (this.$refs.formName.validate()) {
        this.submit();
      }
    },
    submit() {
      let self = this;
      setTimeout(function () {
        self.api.isLoading = true;
        self.api.params = {
          couponKey: self.coupon,
          planKey: "PLAN_PRIMARY_010",
        };
        self.$api.fetch(self.api);
      });
    },
    calculateDiscountedPrice(originalPrice, coupon) {
      if (!coupon) return originalPrice;

      const discountValue = parseFloat(coupon.discountValue);

      if (coupon.discountType === "percentage") {
        const discountAmount = (originalPrice * discountValue) / 100;
        return Math.max(0, originalPrice - discountAmount);
      } else if (coupon.discountType === "fixed_amount") {
        return Math.max(0, originalPrice - discountValue);
      }

      return originalPrice;
    },
    formatDiscount(coupon) {
      if (!coupon) return '';
      
      if (coupon.discountType === 'percentage') {
        return `${coupon.discountValue}%`;
      } else if (coupon.discountType === 'fixed_amount') {
        return `RM ${coupon.discountValue}`;
      }

      return "";
    },
    formatPrice(price) {
      return `RM ${price.toFixed(2)} !!`;
    }
  },
};
</script>

<style scoped>
.text-decoration-line-through {
  text-decoration: line-through;
}
</style>

